"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserEmailPopup = UserEmailPopup;
var _react = _interopRequireDefault(require("react"));
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function UserEmailPopup(_ref) {
  var onAdd = _ref.onAdd,
    onClose = _ref.onClose;
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    bind = _useValidatedForm.bind,
    register = _useValidatedForm.register;
  var onSubmit = function onSubmit() {
    if (!isValid()) return;
    var request = bind();
    onAdd(request.email);
    onClose();
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: (0, _core.translate)('users.additional_emails.popup'),
    onClose: onClose,
    button: {
      text: (0, _core.translate)('buttons.add'),
      onClick: onSubmit
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    name: "email",
    type: "email",
    label: (0, _core.translate)('users.email'),
    register: register,
    required: true
  }));
}